import { SVGProps } from 'react';

export const Cloud = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="113"
    height="79"
    viewBox="0 0 113 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M98.8758 30.1514L98.9174 29.7888C98.9174 13.7003 84.7348 0.654297 67.2299 0.654297C55.4696 0.654297 45.323 6.61068 39.8587 15.3577C37.479 14.2763 34.8529 13.603 32.0215 13.603C22.2972 13.603 14.4173 20.8479 14.4173 29.7888L14.4589 30.1514C6.06657 34.6439 0.333984 42.9187 0.333984 52.449C0.333984 66.6988 13.0158 78.3463 28.5007 78.3463H49.6257V52.449H35.5424L56.6674 26.5516L77.7924 52.449H63.7091V78.3463H84.8341C100.333 78.3463 113.001 66.6988 113.001 52.449C113.001 42.9187 107.268 34.6439 98.8758 30.1514Z"
      fill="#BA2F44"
    />
  </svg>
);
